import { createContext, useContext } from 'react';
export const PageEditorPreviewContext = createContext(false);
export const useIsPageEditorPreview = () => useContext(PageEditorPreviewContext);
